"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "imperia": {
    "c879c4c7": [{
      "hkey": "347e74cc",
      "slug": "borgo-d-oneglia-costa-d-oneglia",
      "name": "Borgo d'Oneglia-Costa d'Oneglia",
      "primary": true,
      "skipSearch": false
    }],
    "costa-d-oneglia": [{
      "hkey": "347e74cc",
      "slug": "borgo-d-oneglia-costa-d-oneglia",
      "name": "Borgo d'Oneglia-Costa d'Oneglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "97247aad": [{
      "hkey": "3b11d57b",
      "slug": "oneglia",
      "name": "Oneglia",
      "primary": true,
      "skipSearch": false
    }],
    "oneglia-cascine": [{
      "hkey": "3b11d57b",
      "slug": "oneglia",
      "name": "Oneglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "imperia"
    }],
    "7c76a48b": [{
      "hkey": "3b11d57b",
      "slug": "oneglia",
      "name": "Oneglia",
      "primary": true,
      "skipSearch": false
    }],
    "oneglia-centro": [{
      "hkey": "3b11d57b",
      "slug": "oneglia",
      "name": "Oneglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "991a7556": [{
      "hkey": "3b11d57b",
      "slug": "oneglia",
      "name": "Oneglia",
      "primary": true,
      "skipSearch": false
    }],
    "oneglia-periferia": [{
      "hkey": "3b11d57b",
      "slug": "oneglia",
      "name": "Oneglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "imperia"
    }],
    "45dbd6ec": [{
      "hkey": "d6391c0b",
      "slug": "poggi",
      "name": "Poggi",
      "primary": true,
      "skipSearch": false
    }],
    "poggi-torrazza": [{
      "hkey": "d6391c0b",
      "slug": "poggi",
      "name": "Poggi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e2f9a432": [{
      "hkey": "827dfeea",
      "slug": "porto-maurizio",
      "name": "Porto Maurizio",
      "primary": true,
      "skipSearch": false
    }],
    "porto-maurizio-borgo-marina": [{
      "hkey": "827dfeea",
      "slug": "porto-maurizio",
      "name": "Porto Maurizio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "imperia"
    }],
    "452a89b2": [{
      "hkey": "827dfeea",
      "slug": "porto-maurizio",
      "name": "Porto Maurizio",
      "primary": true,
      "skipSearch": false
    }],
    "porto-maurizio-centro": [{
      "hkey": "827dfeea",
      "slug": "porto-maurizio",
      "name": "Porto Maurizio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "859a05cb": [{
      "hkey": "827dfeea",
      "slug": "porto-maurizio",
      "name": "Porto Maurizio",
      "primary": true,
      "skipSearch": false
    }],
    "porto-maurizio-periferia": [{
      "hkey": "827dfeea",
      "slug": "porto-maurizio",
      "name": "Porto Maurizio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "imperia"
    }]
  }
};
exports["default"] = _default;